import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { useIsRSNAvailable } from 'src/modules/hooks/useIsRSNAvailable'
import { PlanTypes } from 'src/constants/standaloneData'
import { usPlanData } from 'src/constants/planData/usPlanData'

export default (props) => {
  const { isAvailable } = useIsRSNAvailable(PlanTypes.MASN_PLUS)

  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    video: videos.washington_nationals.videoUrl,
    staticAnnotation: videos.washington_nationals.staticAnnotation,
    pageTitle: 'Watch Washington Nationals baseball',
    title: (
      <>
        Watch Washington Nationals<sup>®</sup> baseball
      </>
    ),
    subtitle: 'Get live games, team news & more',
    networkSet: 'baseball',
    league: 'mlb',
    customNetworks: ['masn'],
    sportId: sportIds.Baseball,
    leagueId: leagueIds.MLB,
    teamId: teamIds['Washington Nationals'],
  }
  return isAvailable ? (
    <FuboFreeTemplate
      {...commonProps}
      hasPlanCards={isAvailable}
      plans={[usPlanData.masn_plus_network_monthly, usPlanData.pro_standalone_monthly]}
      plansSharedData={{
        teams: usPlanData.masn_plus_network_monthly.teams,
      }}
      faqListOverride={faqListOverride}
    />
  ) : (
    <USTemplateDefault {...commonProps} />
  )
}

const faqListOverride = [
  {
    question: 'Can I watch the Baltimore Orioles on Fubo?',
    answer:
      'Yes, you can watch the Baltimore Orioles on Fubo with MASN+, which provides live coverage of their games.',
  },
  {
    question: 'Can I watch the Washington Nationals on Fubo?',
    answer:
      'Yes, the Washington Nationals are available to watch on Fubo via MASN+, ensuring you can catch their live games and events.',
  },
  {
    question: 'Is there commentary and analysis for MLB games on Fubo?',
    answer: 'Yes, MASN+ includes all Orioles Xtra and Nationals Xtra pregame and postgame shows.',
  },
  {
    question: 'Can I watch highlights and replays of Orioles and Nationals games on Fubo?',
    answer:
      'Yes, Fubo provides access to highlights and replays of Orioles and Nationals games through MASN+, allowing you to catch up on any action you may have missed.',
  },
  {
    question: 'What channels can I watch MLB games on Fubo?',
    answer:
      'You can watch MLB games with Fubo on MASN and MASN 2 when you subscribe to MASN+, which broadcasts games for both the Baltimore Orioles and Washington Nationals.',
  },
  {
    question: 'How do I search for specific Orioles or Nationals games on Fubo?',
    answer:
      "To search for specific Orioles or Nationals games on Fubo, use the search function in the app or website and enter the team name or game date to quickly find the content you're looking for.",
  },
  {
    question: 'Are there any special shows related to MLB on Fubo?',
    answer:
      'Yes, when you subscribe to MASN+ with Fubo you will have access to all Orioles Xtra and Nationals Xtra pregame and postgame shows for analysis and in-depth coverage of the Baltimore Orioles and Washington Nationals.',
  },

  {
    question: 'What are the TV channels included FREE with my subscription?',
    answer:
      'The 200+ live TV channels included FREE with your subscription are a great way to stream live TV without cable. This channel lineup is unique to Fubo and a good addition to plan.',
  },
  {
    question: 'Can I watch the included FREE TV channels on my phone and other devices?',
    answer:
      'Yes. Simply download the Fubo app for your phone, smart TV and more, log in, and start streaming.',
  },
  {
    question: 'How does the Unlimited Cloud DVR work?',
    answer:
      'If you’re going to miss a game, show or movie, hit record to watch it later. Recordings are stored in the cloud, so there’s no installation or special equipment required. You can record on one device and watch on another.',
  },
]
